import { render } from "./TopNavMenu.vue?vue&type=template&id=3445446e&scoped=true"
import script from "./TopNavMenu.vue?vue&type=script&lang=js"
export * from "./TopNavMenu.vue?vue&type=script&lang=js"

import "./TopNavMenu.vue?vue&type=style&index=0&id=3445446e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3445446e"]])

export default __exports__